export default __webpack_public_path__ + "static/iot3-6975bab422318bb419c8d1df3cb9c8df.png";